import React, { Component } from 'react'

import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'

export default class Select extends Component{
	render(){
		let { props } = this
		return(
			<div style={{width: "100%", height: "35px", clear: "both"}}>
				<div style={{display:"inline-block", width: "38px", float:"left", marginTop:"5px"}}>
					{props.icon}
				</div>
		        <SelectField
		            hintText={(props.hintText)?props.hintText:""}
		            errorText={(props.errorText)?props.errorText:""}
		            underlineStyle={{
		                borderBottom: "0px solid #b0bec4"
		            }}
					hintStyle = {{
						float: "left"
		              , fontSize: "15px"
					  , fontStyle: "italic"
					  , top: "12px"
					}}
					underlineDisabledStyle ={{display:"none"}}
					disabled={props.disabled}
		            labelStyle = {{
						float: "left"
		              , color: "#000000"
		              , fontSize: "15px"
		            }}
					style={{
						height: "35px"
					  , position: "relative"
					  , top: "-8px"
					  , ...props.style
					}}
		            title={(props.title)?props.title:""}
		            onChange={props.onChange}
		            value={(props.value)?props.value:""}
		        >
					{this.props.children}
		        </SelectField>
		    </div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/Select.js